import { AccountToggleProps } from 'screens/Schedule/AccountToggle/Types'
import Styles from './AccountToggle.module.scss'
import { Account } from 'screens/Schedule/EditChannelsModal/Account'
import ToggleButton from 'common/ToggleButton/ToggleButton'

export const AccountToggle = ({
  integration,
  onChange,
  isSelected,
  name,
  isDisabled = false,
  size = 'normal',
}: AccountToggleProps) => {
  return (
    <div className={Styles.account}>
      <label htmlFor={name} className={Styles.label}>
        <Account integration={integration} />
      </label>
      <ToggleButton
        checked={isSelected}
        name={name}
        handleChange={(e) => {
          onChange(e.target.checked)
        }}
        size={size}
        disabled={isDisabled}
      />
    </div>
  )
}
